// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { Link, useHistory } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "src/actions/loginAction";
// import { connect } from 'react-redux';
// import { getproductCurrency, setSelectedCurrency } from '../../actions/currencyAction';
// // --- DATA ---
// const forclinicLinks = [
//   {
//     label: "Ayurvedic Clinic Management",
//     path: "/ayurvedic-clinic-management",
//   },
//   { label: "Dental Clinic Management", path: "/dental-clinic-management" },
//   {
//     label: "Gynecology Clinic Management",
//     path: "/gynecology-clinic-management",
//   },
//   {
//     label: "Pediatrics Clinic Management",
//     path: "/pediatrics-clinic-management",
//   },
//   {
//     label: "Ophthalmology Clinic Management",
//     path: "/ophthalmology-clinic-management",
//   },
//   {
//     label: "Homeopathy Clinic Management",
//     path: "/homeopathy-clinic-management",
//   },
//   { label: "IVF Clinic Management", path: "/ivf-clinic-management" },
//   { label: "Medicine Clinic Management", path: "/medicine-clinic-management" },
//   {
//     label: "Orthopedic Clinic Management",
//     path: "/orthopedic-clinic-management",
//   },
//   {
//     label: "Physiotherapy Clinic Management",
//     path: "/physiotherapy-clinic-management",
//   },
// ];

// const healthcareLinks = [
//   { label: "Medisevas Hospital ERP", path: "/medisevas-hospital-erp" },
//   {
//     label: "Medisevas Appointment Portal",
//     path: "/medisevas-appointment-portal",
//   },
//   { label: "Queue Management", path: "/queue-management" },
//   { label: "TeleHealthCare Management", path: "/teleHealthCare-management" },
//   { label: "HealthCare Analytics", path: "/hospital-analytics-management" },
//   {
//     label: "Medisevas HealthCare Imaging",
//     path: "/medisevas-healthCare-imaging",
//   },
//   { label: "Materia Medica and Repertory", path: "/materia-medica-repertory" },
// ];

// const laboratoryLinks = [
//   { label: "Pathology Lab Management", path: "/pathology-lab-management" },
//   { label: "Radiology Lab Management", path: "/radiology-lab-management" },
//   { label: "Dental Lab Management", path: "/dental-lab-management" },
//   { label: "Embryology Lab Management", path: "/embryology-lab-management" },
//   { label: "Egg & Sperm Bank Software", path: "/egg-sperm-bank-management" },
//   { label: "Blood Bank Management", path: "/blood-bank-management" },
// ];

// // --- HOOKS ---
// const useOutsideClick = (ref, handler) => {
//   useEffect(() => {
//     const onDoc = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) handler();
//     };
//     document.addEventListener("mousedown", onDoc);
//     return () => document.removeEventListener("mousedown", onDoc);
//   }, [ref, handler]);
// };

// // --- STYLES ---
// const brandColor = "#0084d9";
// const baseLinkStyle = {
//   color: "#0084d9",
//   textDecoration: "none",
//   padding: "5px 0px",
//   borderRadius: 8,
//   fontWeight: 500,
//   whiteSpace: "nowrap",
//   transition: "all .18s",
//   fontSize: "14px",
// };
// const  mobileLinkStyle={
//                   display: "block",
//                   padding: "12px 0",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   color: "#0084d9",
//                   textDecoration: "none",
//                   borderBottom: "1px solid #f0f0f0",
//                 }
// const linkStyle = { ...baseLinkStyle };
// const loginBtnStyle = {
//   background: "transparent",
//   color: brandColor,
//   padding: "10px 20px",
//   borderRadius: "24px",
//   fontWeight: "700",
//   boxShadow: "none",
//   border: `2px solid ${brandColor}`,
//   cursor: "pointer",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   fontSize: "14px",
//   minWidth: "80px",
//   height: "30px",
//   transition: "all 0.3s ease",
// };
// const logoutBtnStyle = { ...loginBtnStyle };

// // --- COMPONENTS ---
// const DropdownMenu = ({
//   id,
//   title,
//   links,
//   openDropdownId,
//   setOpenDropdownId,
//   history,
// }) => {
//   const isOpen = openDropdownId === id;
//   const ref = useRef(null);

//   const closeDropdown = useCallback(() => {
//     if (openDropdownId === id) {
//       setOpenDropdownId(null);
//     }
//   }, [id, openDropdownId, setOpenDropdownId]);

//   const openDropdown = useCallback(
//     () => setOpenDropdownId(id),
//     [id, setOpenDropdownId]
//   );

//   const toggleDropdown = useCallback(() => {
//     setOpenDropdownId(isOpen ? null : id);
//   }, [id, isOpen, setOpenDropdownId]);

//   const handleLinkClick = (path) => {
//     history.push(path);
//     window.scrollTo(0, 0);
//     closeDropdown();
//   };

//   useOutsideClick(ref, closeDropdown);

//   useEffect(() => {
//     const onKey = (e) => {
//       if (e.key === "Escape" && isOpen) {
//         closeDropdown();
//       }
//     };
//     document.addEventListener("keydown", onKey);
//     return () => document.removeEventListener("keydown", onKey);
//   }, [isOpen, closeDropdown]);

//   return (
//     <div ref={ref} style={{ position: "relative" }}>
//       <button
//         id={id}
//         aria-haspopup="true"
//         aria-expanded={isOpen}
//         onClick={toggleDropdown}
//         onMouseEnter={openDropdown}
//         onFocus={openDropdown}
//         style={{
//           display: "inline-flex",
//           alignItems: "center",
//           gap: 8,
//           padding: "5px 10px",
//           borderRadius: 8,
//           border: "none",
//           background: isOpen
//             ? "linear-gradient(90deg,#eaf6ff,#f6fbff)"
//             : "transparent",
//           cursor: "pointer",
//           fontWeight: 700,
//           color: "#0084d9",
//           transition: "all .18s",
//           width: "auto",
//           fontSize: baseLinkStyle.fontSize,
//           fontFamily: "inherit",
//         }}
//       >
//         {title}
//         <span style={{ fontSize: 12, opacity: 0.85, marginLeft: 4 }}>▾</span>
//       </button>

//       {isOpen && (
//         <ul
//           role="menu"
//           aria-labelledby={id}
//           onMouseLeave={closeDropdown}
//           style={{
//             position: "absolute",
//             top: 46,
//             left: 0,
//             minWidth: 240,
//             background: "#fff",
//             boxShadow: "0 8px 28px rgba(2,24,44,0.12)",
//             borderRadius: 12,
//             padding: 8,
//             margin: 0,
//             listStyle: "none",
//             zIndex: 150,
//             transformOrigin: "top center",
//             animation: "pop .14s ease",
//             overflow: "hidden",
//           }}
//         >
//           {links.map((item, i) => (
//             <li key={i} role="none" style={{ margin: 4 }}>
//               <button
//                 role="menuitem"
//                 onClick={() => handleLinkClick(item.path)}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   padding: "10px 12px",
//                   borderRadius: 8,
//                   color: "#03283a",
//                   textDecoration: "none",
//                   fontWeight: 400,
//                   background: "transparent",
//                   border: "none",
//                   width: "100%",
//                   textAlign: "left",
//                   cursor: "pointer",
//                   transition: "background .12s, transform .08s",
//                   whiteSpace: "nowrap",
//                   fontFamily: "inherit",
//                   fontSize: "15px",
//                 }}
//                 onMouseEnter={(e) =>
//                   (e.currentTarget.style.background = "#f3fbff")
//                 }
//                 onMouseLeave={(e) =>
//                   (e.currentTarget.style.background = "transparent")
//                 }
//               >
//                 <span
//                   style={{
//                     width: 8,
//                     height: 8,
//                     borderRadius: 2,
//                     background: "#00a3ff",
//                     display: "inline-block",
//                     opacity: 0.9,
//                   }}
//                 />
//                 <span>{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       )}

//       <style>{`@keyframes pop { from { opacity: 0; transform: scale(.98);} to { opacity:1; transform: scale(1);} }`}</style>
//     </div>
//   );
// };

// const MobileDropdownMenu = ({ title, links, onItemClick, history }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div style={{ marginBottom: "8px" }}>
//       <button
//         onClick={(e) => {
//           e.stopPropagation();
//           setIsOpen(!isOpen);
//         }}
//         style={{
//           width: "100%",
//           textAlign: "left",
//           background: "none",
//           border: "none",
//           padding: "12px 0",
//           fontSize: "16px",
//           fontWeight: "600",
//           color: "#0084d9",
//           cursor: "pointer",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         {title}
//         <span
//           style={{
//             transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
//             transition: "transform 0.3s ease",
//             fontSize: "12px",
//           }}
//         >
//           ▾
//         </span>
//       </button>

//       {isOpen && (
//         <div
//           style={{
//             paddingLeft: "16px",
//             maxHeight: "400px",
//             overflow: "hidden",
//           }}
//         >
//           {links.map((link, index) => (
//             <button
//               key={index}
//               onClick={() => {
//                 history.push(link.path);
//                 window.scrollTo(0, 0);
//                 onItemClick();
//               }}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 padding: "10px 0",
//                 textDecoration: "none",
//                 color: "#03283a",
//                 fontSize: "14px",
//                 borderBottom: "1px solid #f0f0f0",
//                 background: "none",
//                 border: "none",
//                 width: "100%",
//                 textAlign: "left",
//                 cursor: "pointer",
//               }}
//             >
//               <span
//                 style={{
//                   width: "6px",
//                   height: "6px",
//                   backgroundColor: "#00a3ff",
//                   borderRadius: "50%",
//                   marginRight: "12px",
//                   flexShrink: 0,
//                 }}
//               />
//               {link.label}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const HeaderSection = () => {
//   const history = useHistory();
//   const dispatch = useDispatch();
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [openDropdownId, setOpenDropdownId] = useState(null);
//   const { currencyList, selectedCurrency } = useSelector(state => state.currencyReducer);
//   const isAuthenticated = useSelector(
//     (state) => state.loginReducer.isAuthenticated
//   );
//    const [isCurrencyOpen, setIsCurrencyOpen] = useState(false); 
// useEffect(() => {
//     // const hospital_id = localStorage.getItem('hospitalCode');
//     dispatch(getproductCurrency()); // getCurrencies -> getproductCurrency
// }, [dispatch]);

// // handleCurrencyChange ke andar
// // const handleCurrencyChange = (e) => {
// //     const selectedId = e.target.value;
// //     const currency = currencyList.find(c => c.id.toString() === selectedId);
// //     dispatch(setSelectedCurrency(currency)); // Ensure ye action import ho
// // };
// //  const handleCurrencyChange = (e) => {
// //     const selectedId = e.target.value;
// //     // List mein se sahi currency object dhundhein
// //     const currencyObj = currencyList.find(c => c.id.toString() === selectedId);
    
// //     if (currencyObj) {
// //       dispatch(setSelectedCurrency(currencyObj)); // Action call karein
// //     }
// //   };
// const handleCurrencyChange = (e) => {
//     const selectedId = e.target.value;
//     const currencyObj = currencyList.find(c => c.id.toString() === selectedId);
    
//     if (currencyObj) {
//       // Ye action localStorage mein save karega aur Redux state update karega
//       dispatch(setSelectedCurrency(currencyObj)); 
//     }
// };
//   useEffect(() => {
//     if (isMenuOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "unset";
//     }
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, [isMenuOpen]);

//   const toggleMenu = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const closeMenu = () => {
//     setIsMenuOpen(false);
//     setOpenDropdownId(null);
//   };

//   const handleLogin = () => {
//     closeMenu();
//     setTimeout(() => history.push("/login"), 250);
//   };

//   const handleLogout = (e) => {
//     e.preventDefault();
//     dispatch(logout());
//     history.push("/");
//     closeMenu();
//   };

//   const redirectToDashboard = (e) => {
//     e.preventDefault();
//     const role = localStorage.getItem("StaffRole")?.toLowerCase();
//     let path = "/";

//     if (role === "superadmin") {
//       path = "/admin/dashboard";
//     } else if (role === "doctor" || role === "admin") {
//       path = "/doctor/dashboard";
//     } else if (role === "patient") {
//       path = "/patient/dashboard";
//     }

//     closeMenu();
//     setTimeout(() => history.push(path), 250);
//   };

//   const handleNavLinkClick = () => {
//     closeMenu();
//   };

//   return (
//     <>
//       {/* OVERLAY - Closes on click */}
//       {isMenuOpen && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0,0,0,0.5)",
//             zIndex: 1000,
//           }}
//           onClick={closeMenu}
//         />
//       )}

//       <header className="header" style={{ height: "75px" }}>
//         <div
//           className="container"
//           style={{ maxWidth: 1380, margin: "0 auto", height: "100%" }}
//         >
//           <nav
//             className="navbar header-nav"
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               width: "100%",
//               height: "100%",
//               padding: "0 20px",
//             }}
//           >
//             {/* LEFT: logo + hamburger */}
//             <div
//               className="navbar-left"
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "20px",
//                 flex: 1,
//               }}
//             >
//               <div
//                 className="navbar-header"
//                 style={{ display: "flex", alignItems: "center" }}
//               >
//                 <Link
//                   to="/"
//                   onClick={redirectToDashboard}
//                   className="navbar-brand logo py-2 mt-1"
//                   style={{ display: "flex", alignItems: "center" }}
//                 >
//                   <img
//                     src="assets/img/logo.png"
//                     className="img-fluid"
//                     alt="Logo"
//                     style={{ height: "50px", objectFit: "contain" }}
//                   />
//                 </Link>
//               </div>

//               {/* HAMBURGER - ONLY SHOWS ON MOBILE */}
//               <div className="mobile-menu-toggle">
//                 <button
//                   onClick={toggleMenu}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                     padding: "8px",
//                     display: "none",
//                     flexDirection: "column",
//                     gap: "4px",
//                   }}
//                   aria-label="Toggle menu"
//                 >
//                   <span
//                     style={{
//                       width: "24px",
//                       height: "3px",
//                       backgroundColor: "#05475f",
//                       borderRadius: "2px",
//                     }}
//                   />
//                   <span
//                     style={{
//                       width: "24px",
//                       height: "3px",
//                       backgroundColor: "#05475f",
//                       borderRadius: "2px",
//                     }}
//                   />
//                   <span
//                     style={{
//                       width: "24px",
//                       height: "3px",
//                       backgroundColor: "#05475f",
//                       borderRadius: "2px",
//                     }}
//                   />
//                 </button>
//               </div>
//             </div>

//             {/* DESKTOP NAV */}
//             <div
//               className="desktop-right-group"
//               style={{ display: "flex", alignItems: "center", gap: "10px" }}
//             >
//               <div
//                 className="desktop-nav"
//                 style={{ display: "flex", alignItems: "center", gap: 10 }}
//               >
//                 <Link
//                   to="/search-doctor"
//                   style={linkStyle}
//                   onClick={handleNavLinkClick}
//                 >
//                   Doctor & Clinics
//                 </Link>
//                     <Link to="/LabsAndCenters" style={linkStyle} onClick={handleNavLinkClick}>
//     Labs & Centers
//   </Link>
//   <Link to="/HomeAndHealthcare" style={linkStyle} onClick={handleNavLinkClick}>
//     Home Healthcare
//   </Link>
//   <Link to="/PharmacyAndMedicines" style={linkStyle} onClick={handleNavLinkClick}>
//      Pharmacy & Medicines
//   </Link>
//   <Link to="/HealthInsurance" style={linkStyle} onClick={handleNavLinkClick}>
//      Health Insurance
//   </Link>
//                 {/* <DropdownMenu
//                   id="clinic-menu"
//                   title="For Clinic"
//                   links={forclinicLinks}
//                   openDropdownId={openDropdownId}
//                   setOpenDropdownId={setOpenDropdownId}
//                   history={history}
//                 />
//                 <DropdownMenu
//                   id="hospital-menu"
//                   title="For Hospitals"
//                   links={healthcareLinks}
//                   openDropdownId={openDropdownId}
//                   setOpenDropdownId={setOpenDropdownId}
//                   history={history}
//                 />
//                 <DropdownMenu
//                   id="lab-menu"
//                   title="For Laboratory"
//                   links={laboratoryLinks}
//                   openDropdownId={openDropdownId}
//                   setOpenDropdownId={setOpenDropdownId}
//                   history={history}
//                 /> */}
//                 <Link
//                   to="/doctors-blog"
//                   style={linkStyle}
//                   onClick={handleNavLinkClick}
//                 >
//                   Articles
//                 </Link>
//               </div>

//               <ul
//                 className="nav header-navbar-rht"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   listStyle: "none",
//                   margin: 0,
//                   padding: "20px",
//                   gap: "20px",
//                 }}
//               >
//                 <li className="nav-item contact-item" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
//                   <div className="contact-info" style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
//                     {/* <span className="py-1" style={{ fontWeight: 900 , fontSize: 13, color: '#090202', letterSpacing: '0.6px' }}>Helpline No </span>
//                     <p style={{ fontSize: 11, color: '#090202' }}>+91 7028287002</p> */}
//                     {/* <div 
//     style={{ 
//         display: 'inline-block', // Fits the box to the content width
//         border: '1px solid #0084d9', // Simple border for the box structure
//         padding: '8px 12px', 
//         borderRadius: '5px', 
       
//         pointerEvents: 'none', // Prevents any clicking/hover effects
//         userSelect: 'none' // Prevents text selection
//     }}
// >
//     <span 
//         style={{ 
//             fontWeight: 900, 
//             fontSize: 13, 
//             color: '#090202', 
//             letterSpacing: '0.6px',
//             display: 'block', // Ensures it stays on its own line
//             marginBottom: '2px' 
//         }}
//     >
//         Helpline No
//     </span>
//     <p 
//         style={{ 
//             fontSize: 11, 
//             color: '#090202', 
//             margin: 0 // Removes default p-tag spacing
//         }}
//     >
//         +91 7028287002
//     </p>
// </div> */}
// {/* --- CURRENCY DROPDOWN START --- */}
//         <li className="nav-item" style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//           {/* <select 
//   // Ye sabse important line hai:
//   value={selectedCurrency?.id || ""} 
//   onChange={handleCurrencyChange}
//   style={{
//     padding: '5px 8px',
//     borderRadius: '20px',
//     border: '2px solid #0084d9',
//     color: '#0084d9',
//     fontWeight: 'bold',
//     cursor: 'pointer'
//   }}
// >
//   <option value="" disabled>Select Currency</option>
//   {currencyList && currencyList.map(curr => (
//     <option key={curr.id} value={curr.id}>
//        {curr.currency_name} ({curr.symbol})
//     </option>
//   ))}
// </select> */}
//  {/* --- PROFESSIONAL CURRENCY DROPDOWN --- */}
// <li className="nav-item" style={{ position: 'relative', display: 'flex', alignItems: 'center', marginRight: '15px' }}>
  
//   {/* Selected Currency Badge (Jo hamesha dikhega) */}
//   <div 
//     onClick={() => setIsCurrencyOpen(!isCurrencyOpen)}
//     style={{
//       width: '40px', // Choti width
//       height: '34px',
//       borderRadius: '10px',
//       border: '2px solid #0084d9',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       color: '#0084d9',
//       fontWeight: 'bold',
//       fontSize: '16px',
//       transition: 'all 0.3s ease',
//       boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
//     }}
//     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f8ff'}
//     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
//   >
//     {selectedCurrency?.symbol || '₹'}
//     <span style={{ fontSize: '10px', marginLeft: '2px' }}>▼</span>
//   </div>

//   {/* Dropdown Menu (Jo click par khulega) */}
//   {isCurrencyOpen && (
//     <>
//       {/* Overlay: Taaki bahar click karne par band ho jaye */}
//       <div 
//         style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 998 }} 
//         onClick={() => setIsCurrencyOpen(false)} 
//       />
      
//       <ul style={{
//         position: 'absolute',
//         top: '40px',
//         right: '0',
//         minWidth: '200px', // Andar full name dikhane ke liye width
//         backgroundColor: '#fff',
//         borderRadius: '8px',
//         boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
//         listStyle: 'none',
//         padding: '5px 0',
//         margin: 0,
//         zIndex: 999,
//         border: '1px solid #eee',
//         animation: 'popIn 0.2s ease-out'
//       }}>
//         {currencyList && currencyList.map(curr => (
//           <li 
//             key={curr.id}
//             onClick={() => {
//               dispatch(setSelectedCurrency(curr));
//               setIsCurrencyOpen(false);
//             }}
//             style={{
//               padding: '10px 15px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               color: selectedCurrency?.id === curr.id ? '#0084d9' : '#333',
//               backgroundColor: selectedCurrency?.id === curr.id ? '#f0f8ff' : 'transparent',
//               display: 'flex',
//               justifyContent: 'space-between',
//               fontWeight: selectedCurrency?.id === curr.id ? '700' : '400',
//               transition: 'background 0.2s'
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCurrency?.id === curr.id ? '#f0f8ff' : 'transparent'}
//           >
//             <span>{curr.currency_name}</span>
//             <span style={{ fontWeight: 'bold' }}>({curr.symbol})</span>
//           </li>
//         ))}
//       </ul>
//     </>
//   )}
// </li>

// <style>{`
//   @keyframes popIn {
//     from { opacity: 0; transform: translateY(-10px) scale(0.95); }
//     to { opacity: 1; transform: translateY(0) scale(1); }
//   }
// `}</style>
//         </li>
      
      
//                   </div>
//                 </li>
                
//                 <li className="nav-item">
//                   {isAuthenticated ? (
//                     <button onClick={handleLogout} style={logoutBtnStyle}>
//                       Logout
//                     </button>
//                   ) : (
//                     <button onClick={handleLogin} style={loginBtnStyle}>
//                       Sign in
//                     </button>
//                   )}
//                 </li>
//               </ul>
//             </div>
//           </nav>
//         </div>

//         {/* MOBILE SIDEBAR */}
//         <div
//           className={`mobile-sidebar ${isMenuOpen ? "opened" : ""}`}
//           style={{
//             position: "fixed",
//             top: 0,
//             left: isMenuOpen ? 0 : "-100%",
//             width: "320px",
//             maxWidth: "85%",
//             height: "100vh",
//             background: "#fff",
//             zIndex: 1001,
//             transition: "left 0.3s ease",
//             boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
//             overflowY: "auto",
//             paddingBottom: "100px",
//           }}
//         >
//           <div
//             style={{
//               padding: "20px",
//               borderBottom: "1px solid #f0f0f0",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <Link
//               to="/"
//               onClick={(e) => {
//                 e.preventDefault();
//                 redirectToDashboard(e);
//               }}
//               className="sidebar-logo"
//             >
//               <img
//                 src="/assets/img/logo.png"
//                 className="img-fluid"
//                 alt="Logo"
//                 style={{ height: "40px" }}
//               />
//             </Link>
//             <button
//               onClick={closeMenu}
//               style={{
//                 background: "none",
//                 border: "none",
//                 fontSize: "24px",
//                 cursor: "pointer",
//               }}
//             >
//               ×
//             </button>
//           </div>

//           <div style={{ padding: "20px" }}>
//             <nav onClick={(e) => e.stopPropagation()}>
//               <Link
//                 to="/search-doctor"
//                 onClick={handleNavLinkClick}
//                 style={{
//                   display: "block",
//                   padding: "12px 0",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   color: "#0084d9",
//                   textDecoration: "none",
//                   borderBottom: "1px solid #f0f0f0",
//                 }}
//               >
//                  Doctor & Clinics
//               </Link>
//                  <Link to="/LabsAndCenters" onClick={handleNavLinkClick} style={mobileLinkStyle}>
//     Labs & Centers
//   </Link>
//   <Link to="/HomeAndHealthcare" onClick={handleNavLinkClick} style={mobileLinkStyle}>
//     Home Healthcare
//   </Link>
//   <Link to="/PharmacyAndMedicines" onClick={handleNavLinkClick} style={mobileLinkStyle}>
//     Pharmacy & Medicines
//   </Link>
//   <Link to="/HealthInsurance" onClick={handleNavLinkClick} style={mobileLinkStyle}>
//     Health Insurance
//   </Link>
//               {/* <MobileDropdownMenu
//                 title="For Clinic"
//                 links={forclinicLinks}
//                 onItemClick={closeMenu}
//                 history={history}
//               />
//               <MobileDropdownMenu
//                 title="For Hospitals"
//                 links={healthcareLinks}
//                 onItemClick={closeMenu}
//                 history={history}
//               />
//               <MobileDropdownMenu
//                 title="For Laboratory"
//                 links={laboratoryLinks}
//                 onItemClick={closeMenu}
//                 history={history}
//               /> */}

//               <Link
//                 to="/doctors-blog"
//                 onClick={handleNavLinkClick}
//                 style={{
//                   display: "block",
//                   padding: "12px 0",
//                   fontSize: "16px",
//                   fontWeight: "600",
//                   color: "#0084d9",
//                   textDecoration: "none",
//                   borderBottom: "1px solid #f0f0f0",
//                 }}
//               >
//                 Articles
//               </Link>

//               {/* <div
//                 style={{
//                   marginTop: "20px",
//                   padding: "16px",
//                   backgroundColor: "#f8f9fa",
//                   borderRadius: "8px",
//                   border: "1px solid #e9ecef",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     flexDirection: "column",
//                     lineHeight: 1.4,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontWeight: 700,
//                       fontSize: 14,
//                       color: "#0084d9",
//                       marginBottom: "4px",
//                     }}
//                   >
//                     Helpline No
//                   </span>
//                   <span style={{ fontSize: 13, color: "#0084d9" }}>
//                     +91 7028287002
//                   </span>
//                 </div>
//               </div> */}

//               <div style={{ marginTop: "20px" }}>
//                 {isAuthenticated ? (
//                   <button
//                     onClick={handleLogout}
//                     style={{
//                       ...logoutBtnStyle,
//                       width: "100%",
//                       fontSize: "16px",
//                       height: "44px",
//                     }}
//                   >
//                     Logout
//                   </button>
//                 ) : (
//                   <button
//                     onClick={handleLogin}
//                     style={{
//                       ...loginBtnStyle,
//                       width: "100%",
//                       fontSize: "16px",
//                       height: "44px",
//                     }}
//                   >
//                     Sign in
//                   </button>
//                 )}
//               </div>
//             </nav>
//           </div>
//         </div>

//         <div style={{ height: "5px", backgroundColor: "#0084d9" }} />
//         <div style={{ height: "8px", backgroundColor: "#046525" }} />
//       </header>

//       <style>{`
//         @media (max-width: 1200px) {
//           .mobile-menu-toggle button {
//             display: flex !important;
//           }
//           .desktop-right-group {
//             display: none !important;
//           }
//         }
        
//         @media (min-width: 1201px) {
//           .mobile-menu-toggle button {
//             display: none !important;
//           }
//           .desktop-right-group {
//             display: flex !important;
//           }
//         }
        
//         @keyframes pop {
//           from { opacity: 0; transform: scale(.98); }
//           to { opacity: 1; transform: scale(1); }
//         }
         
//       `}</style>
//     </>
//   );
// };

// export default HeaderSection;



































import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "src/actions/loginAction";
import { getproductCurrency, setSelectedCurrency } from "../../actions/currencyAction";

// --- STYLES ---
const brandColor = "#0084d9";
const greenBarColor = "#046525";

const HeaderSection = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCurrencyOpen, setIsCurrencyOpen] = useState(false);
  const currencyRef = useRef(null);

  const { currencyList, selectedCurrency } = useSelector((state) => state.currencyReducer);
  const isAuthenticated = useSelector((state) => state.loginReducer.isAuthenticated);

  useEffect(() => {
    dispatch(getproductCurrency());
  }, [dispatch]);

  // const handleCurrencyChange = (curr) => {
  //   dispatch(setSelectedCurrency(curr));
  //   setIsCurrencyOpen(false);
  // };
  const handleNavLinkClick = () => {
    closeMenu();
  };
  const loginBtnStyle = {
  background: brandColor,
  color: "#fff",
  padding: "8px 24px",
  borderRadius: "30px",
  fontWeight: "600",
  border: `2px solid ${brandColor}`,
  cursor: "pointer",
  fontSize: "14px",
  transition: "all 0.3s ease",
};

const logoutBtnStyle = {
  background: "transparent",
  color: brandColor,
  padding: "8px 24px",
  borderRadius: "30px",
  fontWeight: "600",
  border: `2px solid ${brandColor}`,
  cursor: "pointer",
  fontSize: "14px",
  transition: "all 0.3s ease",
};
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleLogin = () => { closeMenu(); history.push("/login"); };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    history.push("/");
    closeMenu();
  };

  // const redirectToDashboard = (e) => {
  //   e.preventDefault();
  //   const role = localStorage.getItem("StaffRole")?.toLowerCase();
  //   //  alert("Role is: " + role); 
  //   let path = "/";
  //   if (role === "superadmin") path = "/admin/dashboard";
  //   else if (role === "doctor" || role === "admin") path = "/doctor/dashboard";
  //   else if (role === "patient") path = "/patient/dashboard";
  //   closeMenu();
  //   history.push(path);
  // };
const redirectToDashboard = (e) => {
  if (e) e.preventDefault();
  const role = localStorage.getItem("StaffRole")?.toLowerCase();
  let path = "/";
  
  if (role === "superadmin") path = "/admin/dashboard";
  else if (role === "doctor" || role === "admin") path = "/doctor/dashboard";
  else if (role === "patient") path = "/patient/dashboard";
  else path = "/"; // default agar role na mile

  closeMenu();
  history.push(path);
};
  const handleCurrencyChange = (curr) => {
  dispatch(setSelectedCurrency(curr));
  setIsCurrencyOpen(false);
};

// Add this inside your component
useEffect(() => {
  const handleClickOutside = (event) => {
    if (currencyRef.current && !currencyRef.current.contains(event.target)) {
      setIsCurrencyOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);
  // Inline dynamic styles for Desktop Links
  const navLinkStyle = {
    color: "#333",
    textDecoration: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "14px",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
    position: "relative",
    display: "flex",
    alignItems: "center"
  };

  const authBtnStyle = {
    background: "transparent",
    color: brandColor,
    padding: "8px 22px",
    borderRadius: "24px",
    fontWeight: "700",
    border: `2px solid ${brandColor}`,
    cursor: "pointer",
    fontSize: "14px",
    height: "36px",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  return (
    <>
      <header className="header" style={{ height: "auto", background: "#fff" }}>
        <div className="container" style={{ maxWidth: 1400, margin: "0 auto" }}>
          <nav className="navbar" style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "75px",
            padding: "0 20px",
            gap: "10px"
          }}>
            
            {/* LOGO */}
            <div style={{ flexShrink: 0 }}>
              <Link to="/" onClick={redirectToDashboard} style={{ display: "flex", alignItems: "center" }}>
                <img src="assets/img/logo.png" alt="Logo" style={{ height: "52px", objectFit: "contain" }} />
              </Link>
            </div>

            {/* DESKTOP TABS (CENTER) */}
            <div className="desktop-tabs" style={{ 
              display: "flex", 
              alignItems: "center", 
              gap: "4px", 
              flex: 1, 
              justifyContent: "center" 
            }}>
              <Link to="/search-doctor" className="nav-tab-item" style={navLinkStyle}>Doctor & Clinics</Link>
              <Link to="/LabsAndCenters" className="nav-tab-item" style={navLinkStyle}>Labs & Centers</Link>
              <Link to="/HomeAndHealthcare" className="nav-tab-item" style={navLinkStyle}>Health Caretaker</Link>
              <Link to="/PharmacyAndMedicines" className="nav-tab-item" style={navLinkStyle}>Pharmacy & Medicines</Link>
              <Link to="/HealthInsurance" className="nav-tab-item" style={navLinkStyle}>Health Insurance</Link>
              <Link to="/doctors-blog" className="nav-tab-item" style={navLinkStyle}>Articles</Link>
            </div>

            {/* DESKTOP ACTIONS (RIGHT) */}
            <div className="desktop-actions" style={{ display: "flex", alignItems: "center", gap: "15px", flexShrink: 0 }}>
              {/* Currency Dropdown */}
              <div ref={currencyRef} style={{ position: "relative" }}>
                <button onClick={() => setIsCurrencyOpen(!isCurrencyOpen)} style={{
                  display: "flex", alignItems: "center", gap: 6, padding: "8px 16px",
                  border: `1.5px solid ${brandColor}`, borderRadius: "30px", background: "#fff",
                  color: brandColor, fontWeight: "700", cursor: "pointer", fontSize: "14px"
                }}>
                  <span>{selectedCurrency?.symbol || '₹'}</span>
                  <span style={{ fontSize: 10 }}>▼</span>
                </button>
                {isCurrencyOpen && (
                  <ul style={{ position: "absolute", top: "110%", right: 0, minWidth: "190px", background: "#fff", borderRadius: "12px", boxShadow: "0 8px 25px rgba(0,0,0,0.15)", padding: "8px 0", listStyle: "none", zIndex: 1000 }}>
                    {currencyList?.filter(curr => curr.status !== "Inactive") .map(curr => (
                      <li key={curr.id} onClick={() => handleCurrencyChange(curr)} style={{ padding: "10px 16px", cursor: "pointer", fontSize: "14px", display: "flex", justifyContent: "space-between", color: "#333" }} className="currency-item">
                        <span>{curr.currency_name}</span> <span style={{ fontWeight: "bold", color: brandColor }}>{curr.symbol}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Auth Button */}
              {isAuthenticated ? (
                <button onClick={handleLogout} style={authBtnStyle} className="auth-btn">Logout</button>
              ) : (
                <button onClick={handleLogin} style={{ ...authBtnStyle, background: brandColor, color: "#fff" }} className="auth-btn sign-in">Sign in</button>
              )}
            </div>

            {/* MOBILE TOGGLE */}
            <button onClick={toggleMenu} className="mobile-toggle" style={{ display: "none", background: "none", border: "none", cursor: "pointer", flexDirection: "column", gap: "5px" }}>
              <span style={{ width: "24px", height: "3px", backgroundColor: brandColor, borderRadius: "2px" }} />
              <span style={{ width: "24px", height: "3px", backgroundColor: brandColor, borderRadius: "2px" }} />
              <span style={{ width: "24px", height: "3px", backgroundColor: brandColor, borderRadius: "2px" }} />
            </button>
          </nav>
        </div>

        {/* COLORED BARS (Exactly as your previous design) */}
        <div style={{ height: "5px", backgroundColor: brandColor }} />
        <div style={{ height: "8px", backgroundColor: greenBarColor }} />
      </header>

      {/* MOBILE SIDEBAR UI */}
      {isMenuOpen && (
         <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                background: "rgba(0,0,0,0.5)",
                opacity: isMenuOpen ? 1 : 0,
                visibility: isMenuOpen ? "visible" : "hidden",
                transition: "all 0.3s ease",
                zIndex: 1001,
              }} onClick={closeMenu}>
                <div style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "85%",
                  maxWidth: 320,
                  height: "100vh",
                  background: "#fff",
                  transform: isMenuOpen ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 0.3s ease",
                  overflowY: "auto",
                  boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
                }} onClick={(e) => e.stopPropagation()}>
                  
                  {/* Sidebar Header */}
                  {/* <div style={{
                    padding: "20px",
                    borderBottom: "1px solid #f0f0f0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                    <img
                      src="assets/img/logo.png"
                      alt="Logo"
                      style={{ height: 40 }}
                    />
                    <button
                      onClick={closeMenu}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: 24,
                        cursor: "pointer",
                        color: "#666",
                      }}
                    >
                      ×
                    </button>
                  </div> */}
                  <div style={{
  padding: "20px",
  borderBottom: "1px solid #f0f0f0",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}}>
  {/* LOGO PAR DASHBOARD LINK */}
  <Link to="/" onClick={redirectToDashboard}>
    <img src="assets/img/logo.png" alt="Logo" style={{ height: 40 }} />
  </Link>
  <button onClick={closeMenu} style={{ background: "none", border: "none", fontSize: 24 }}>×</button>
</div>
        
                  {/* Sidebar Content */}
                  <div style={{ padding: "20px" }}>
                    {/* User Info */}
                    {/* Sidebar User Info Section */}
<div 
  onClick={(e) => {
    if (isAuthenticated) {
      redirectToDashboard(e); // Login hai toh dashboard par jaye
    } else {
      handleLogin(); // Guest hai toh login page par jaye
    }
  }}
  style={{
    padding: "15px",
    background: "#f8f9fa",
    borderRadius: 12,
    marginBottom: 20,
    cursor: "pointer",
    border: `1px solid ${isAuthenticated ? '#e0e0e0' : brandColor}`, // Guest ke liye border color alag dikhega
    transition: "all 0.3s ease"
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
    <div style={{
      width: 45, height: 45, borderRadius: "50%",
      background: isAuthenticated ? brandColor : "#0084d9", // Guest ke liye grey circle
      color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 18, fontWeight: "bold",
    }}>
      {isAuthenticated ? "U" : "G"} {/* Guest ke liye question mark ya user icon */}
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 600, fontSize: 16 }}>
        {isAuthenticated ? "Welcome Back!" : "Guest User"}
      </div>
      <div style={{ 
        fontSize: 13, 
        color: brandColor, 
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between" 
      }}>
        {isAuthenticated ? "View Dashboard →" : "Click to Login →"}
      </div>
    </div>
  </div>
</div>
        
                    {/* Currency Selector */}
                    <div style={{
                      padding: "15px",
                      background: "#f8f9fa",
                      borderRadius: 12,
                      marginBottom: 20,
                    }}>
                      <div style={{ fontSize: 14, color: "#666", marginBottom: 10 }}>
                        Select Currency
                      </div>
                      <select
                        value={selectedCurrency?.id || ""}
                        onChange={(e) => {
                          const curr = currencyList?.find(c => c.id.toString() === e.target.value);
                          if (curr) handleCurrencyChange(curr);
                        }}
                        style={{
                          width: "100%",
                          padding: "12px",
                          borderRadius: 8,
                          border: `1.5px solid ${brandColor}`,
                          color: brandColor,
                          fontWeight: 600,
                          outline: "none",
                          fontSize: 14,
                        }}
                      >
                        <option value="" disabled>Select Currency</option>
                        {currencyList?.filter(curr => curr.status !== "Inactive") .map(curr => (
                          <option key={curr.id} value={curr.id}>
                            {curr.currency_name} ({curr.symbol})
                          </option>
                        ))}
                      </select>
                    </div>
        
                    {/* Navigation Links */}
                    <div style={{ marginBottom: 20 }}>
                      <Link
                        to="/search-doctor"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Doctor & Clinics
                      </Link>
                      <Link
                        to="/LabsAndCenters"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Labs & Centers
                      </Link>
                      <Link
                        to="/HomeAndHealthcare"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Health Caretaker
                      </Link>
                      <Link
                        to="/PharmacyAndMedicines"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Pharmacy & Medicines
                      </Link>
                      <Link
                        to="/HealthInsurance"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Health Insurance
                      </Link>
                      <Link
                        to="/doctors-blog"
                        onClick={handleNavLinkClick}
                        style={{
                          display: "block",
                          padding: "15px 0",
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#333",
                          textDecoration: "none",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        Articles
                      </Link>
                    </div>
        
                    {/* Helpline */}
                    <div style={{
                      padding: "15px",
                      background: "#f8f9fa",
                      borderRadius: 12,
                      textAlign: "center",
                    }}>
                      <div style={{ fontSize: 12, color: "#666" }}>Helpline No</div>
                      <div style={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: brandColor,
                        marginTop: 5,
                      }}>
                        +91 7028287002
                      </div>
                    </div>
        
                    {isAuthenticated && (
                      <button
                        onClick={handleLogout}
                        style={{
                          width: "100%",
                          ...logoutBtnStyle,
                          marginTop: 20,
                          padding: "12px",
                        }}
                      >
                        Logout
                      </button>
                    )}
                  </div>
                </div>
              </div>
      )}

      {/* CUSTOM HOVER AND RESPONSIVE STYLES */}
      <style>{`
        /* Desktop Tab Hover Effect */
        .nav-tab-item:hover {
          color: ${brandColor} !important;
          background-color: #f0f8ff;
        }

        /* Bottom indicator line on hover */
        .nav-tab-item::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 18px;
          right: 18px;
          height: 2px;
          background-color: ${brandColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }
        .nav-tab-item:hover::after {
          transform: scaleX(1);
        }

        /* Currency dropdown hover */
        .currency-item:hover {
          background-color: #f5faff;
        }

        /* Sign in button hover */
        .auth-btn.sign-in:hover {
          opacity: 0.9;
          box-shadow: 0 4px 12px rgba(0, 132, 217, 0.3);
        }
        
        .auth-btn:not(.sign-in):hover {
          background-color: #f0f8ff;
        }

        /* Responsive Breakpoint */
        @media (max-width: 1280px) {
          .desktop-tabs, .desktop-actions {
            display: none !important;
          }
          .mobile-toggle {
            display: flex !important;
          }
        }
            @media (max-width: 1366px) { /* Pehle 1280 tha, ise 1366 kar diya taaki 13-inch laptop par mobile menu dikhe */
    .desktop-tabs, .desktop-actions {
      display: none !important;
    }
    .mobile-toggle {
      display: flex !important;
    }
  }

  @media (min-width: 1367px) {
    .desktop-tabs, .desktop-actions {
      display: flex !important;
    }
    .mobile-toggle {
      display: none !important;
    }
  }

  /* Tabs text ko thoda chota karna taaki overflow na ho */
  @media (max-width: 1440px) and (min-width: 1367px) {
    .nav-tab-item {
      padding: 10px 10px !important; /* Padding kam kar di */
      font-size: 13px !important;     /* Font size chota kar diya */
    }
  }

  .nav-tab-item:hover { color: ${brandColor} !important; background-color: #f0f8ff; }
  .currency-item:hover { background-color: #f5faff; }
      `}</style>
    </>
  );
};

export default HeaderSection;